import type { SelectOption, StatusIndicatorProps, BadgeVariant } from '@chatsdet/ui';
export type WorkflowStatus =
  | 'draft'
  | 'approved'
  | 'deleted'
  | 'generating';

export const DEFAULT_WORKFLOW_NAME = 'Untitled Workflow';

const _workflowStatusOptions: SelectOption[] = [
  { id: 'draft', label: 'Draft' },
  { id: 'approved', label: 'Approved' },
  { id: 'deleted', label: 'Deleted' },
  { id: 'generating', label: 'Generating' },
];

const _automationStrategyOptions: SelectOption[] = [{ id: 'playwright', label: 'Playwright' }];

const _browserModeOptions: SelectOption[] = [
  { id: 'headless', label: 'Headless (default)' },
  { id: 'headed', label: 'Headed' },
];

const _workflowStatusBadgeVariant: Record<
  WorkflowStatus,
  BadgeVariant
> = {
  draft: 'secondary',
  approved: 'success',
  deleted: 'destructive',
  generating: 'secondary',
};

const _workflowStatusIndicatorVariant: Record<WorkflowStatus, StatusIndicatorProps['variant']> = {
  draft: 'notice',
  approved: 'positive',
  deleted: 'neutral',
  generating: 'info',
};
